<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface AvatarGroupProps {
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<AvatarGroupProps>()
</script>

<template>
  <div data-slot="avatar-group" :class="cn('flex shrink-0 items-center -space-x-2', props.class)">
    <slot />
  </div>
</template>
